import {StringUtils, Logger} from 'neo-common';
import {ClientHostDialogRequest, ClientHostDialogType, ClientHostResponsibleDialogData} from '../ClientHost/Types';
import {RealityCheckBase} from './RealityCheckBase';
import {registerRealityCheck} from './RealityCheckFactory';

const DefaultInterval = 300;
const loggerName = 'DefaultRealityCheck';
const typeName = 'Default';

@registerRealityCheck(typeName)
export class DefaultRealityCheck extends RealityCheckBase {
    private _timerHandle: any;
    private _startInterval: number;
    private _interval: number;
    private _startTime: Date;
    private _timerData: ClientHostResponsibleDialogData;

    public get name(): string {
        return 'Default';
    }

    public get version(): string {
        return '1.0';
    }

    public get loggerName(): string {
        return loggerName;
    }

    protected doInitialize() {
        this._interval = this._gameConfiguration.RealityCheckInterval;
        if (this._interval <= 0) {
            if (DEBUG) {
                Logger.debugGroup(loggerName,
                    `'RealityCheckInterval' has invalid value (${this._interval}), ` +
                    `changed to default value (${DefaultInterval}).`);
            }

            this._interval = DefaultInterval;
        }

        this._startInterval = this._gameConfiguration.RealityCheckStartInterval;
        if (this._startInterval <= 0) {
            if (DEBUG) {
                Logger.debugGroup(loggerName,
                    `'RealityCheckStartInterval' has invalid value (${this._startInterval}), ` +
                    `changed to interval value (${this._interval}).`);
            }

            this._startInterval = this._interval;
        }

        this._startTime = new Date(new Date().getTime());
        this._timerHandle = undefined;
        this.handleTimer = this.handleTimer.bind(this);
    }

    public start(): void {
        if (DEBUG) {
            Logger.debugGroup(loggerName, `Starting reality check, 1st dialog will shows after ${this._startInterval} seconds from now`);
        }

        this._timerData = {
            exit: !StringUtils.isNullOrEmpty(this._gameConfiguration.ExitUrl),
            history: !StringUtils.isNullOrEmpty(this._gameConfiguration.HistoryUrl),
            continue: true,
            startTime: this._startTime,
            interval: this._interval
        };

        this.resetTimer(this._startInterval);
    }

    public reset(): void {
        if (DEBUG) {
            Logger.debugGroup(loggerName, `Restarting reality check, dialog will shows after ${this._interval} seconds from now`);
        }

        this.resetTimer(this._interval);
    }

    /**
     * reset timer
     * @param interval - interval in seconds
     */
    private resetTimer(interval: number) {
        this.clearTimer();
        this._timerHandle = setTimeout(this.handleTimer, interval * 1000);
    }

    private clearTimer(): void {
        if (this._timerHandle) {
            clearTimeout(this._timerHandle);
            this._timerHandle = undefined;
        }
    }

    private handleTimer(): void {
        this.clearTimer();

        const request: ClientHostDialogRequest = {
            type: ClientHostDialogType.Responsible1,
            text: '',
            error: null,
            data: this._timerData
        };

        this.invokeTimerExpired(request);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/RealityCheck/DefaultRealityCheck.ts
 **/